import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from '../components/dashboard.vue'
import Login from '../components/login.vue'
import sso from '../components/sso.vue'
import config from "@/config";

Vue.use(VueRouter)

const routes = [
  {
    path: '/', redirect: '/dashboard'
  },
  {
    path: '/dashboard', component: Dashboard
  },
  {
    path: '/login', component: Login
  },
  {
    path: '/sso', component: sso
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  let login = sessionStorage.getItem('isLogin')
  let isLogin = false
  if (login != null && login == 1) {
    isLogin = true
  } else {
    isLogin = false
  }
  const ssoUrl = config.ssoUrl;
  if (to.path == '/login') {
    if (!isLogin) {
      next();
    } else {
      next({ path: '/dashboard' })
    }
  } else if (to.path == '/sso') {
    next();
  } else {
    if (!isLogin) {

      if (config.sso == '1') {
        location.href = ssoUrl;
      }else {
        next({ path: '/login' })
      }
    } else {
      return next();
    }
  }
})

export default router
